export function isExpiredByDays(since_date: Date, min_days: number, max_days: number) {
  const now = new Date();
  const elapsed_milliseconds = (now.getTime() - since_date.getTime());
  const elapsed_days = Math.floor(elapsed_milliseconds / (1000 * 60 * 60 * 24));
  return {
    elapsed_days,
    expired: (elapsed_days <= max_days
    && elapsed_days > min_days),
  };
}
